<template>
  <Modal v-model="isOpen" :close="() => { setModal(false) }">
    <div class="lcu-modal">
      <div class="lcu-confirm-body">
        <div class="row row-center">
            <p class="lcu-center-text">
                ¿Estás seguro de que quieres ir a la siguiente
                sección? Ya no podrás regresar a este examen.
            </p>
        </div>
        <div class="row">
            <button-cta
                :text="'Sí, Ir Ahora'"
                @on-click="onConfirm" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import ButtonCta from 'ç/buttons/Cta.vue';

export default {
  name: 'confirm-next-section-modal',
  components: {
    ButtonCta,
  },
  props: [
    'is-open',
    'onConfirm',
  ],
  methods: {
    setModal(val) {
      this.$emit('set-modal', val);
    },
  },
};
</script>
